import React from "react";
import {
  Row,
  Image,
  Label,
  RootContainer,
  SubContainer,
  Title,
  TitleWrapper,
  Col,
  Button,
  MarqueeLabel,
} from "./SportCard.style";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setAlert, setPrevRoute } from "@redux/game/gameSlice";
import { useGame } from "@hooks";
import { useLocation } from "react-router-dom";

const SportCard = ({ football_agents }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { launchGame } = useGame();
  const { pathname, search } = useLocation();

  const handleGameClicked = (game) => {
    if (!game.active) {
      dispatch(
        setAlert({
          title: t("maintain.maintainTitle"),
          description: (
            <>
              {t("maintain.maintainSubtitle1")} <br />{" "}
              {t("maintain.maintainSubtitle2")}
            </>
          ),
          open: true,
          maintain: true,
        })
      );
      return;
    }

    /**
     * Save pathname to redux,
     * to use from ingame page for going back
     **/
    dispatch(setPrevRoute(pathname + search));
    /**
     * Launch game
     */
    launchGame(game);
  };

  return (
    <RootContainer>
      <TitleWrapper>
        <Title>{t("home.sportTitle")}</Title>
      </TitleWrapper>
      <Row gutter={20}>
        {football_agents.map((football_agent, index) => (
          <Col key={index}>
            <SubContainer>
              <Image src={football_agent.icon} alt={football_agent.name} />
              {football_agent.name.length > 16 ? (
                <MarqueeLabel>{football_agent.name}</MarqueeLabel>
              ) : (
                <Label>{football_agent.name}</Label>
              )}
              <Button
                type="primary"
                onClick={() => handleGameClicked(football_agent)}
              >
                {t("home.play")}
              </Button>
            </SubContainer>
          </Col>
        ))}
      </Row>
    </RootContainer>
  );
};

export default SportCard;
